import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef(({
  className,
  ...props
}, ref) => {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border shadow-xs transition-all outline-none",
        // background colors
        "data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted",
        // border colors
        "border-border focus-visible:border-ring",
        // focus ring
        "focus-visible:ring-[3px] focus-visible:ring-ring/50",
        // disabled state
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}>
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block size-4 rounded-full ring-0 transition-transform",
          // colors
          "bg-background dark:bg-primary-foreground",
          // position based on peer (root) state
          "peer-data-[state=checked]:translate-x-[calc(100%-2px)] peer-data-[state=unchecked]:translate-x-0"
        )} />
    </SwitchPrimitive.Root>
  );
})
Switch.displayName = "Switch"

export { Switch }
